// Countries whose postal codes have 4 digits instead of 5.
const POSTAL_CODE_LENGTHS = {
  Belgique: 4,
  Luxembourg: 4,
  Suisse: 4
};

/**
 * Whether the address must have a French département. Elsewhere the field is
 * an optional province or region. Without a country yet, it stays required.
 * @param {string} [country] - The country name, as in the country select.
 * @returns {boolean} True for France or no country.
 */
export const requiresDepartment = (country) => !country || country === 'France';

/**
 * Number of characters a postal code needs before the city lookup runs.
 * @param {string} [country] - The country name, as in the country select.
 * @returns {number} 4 for Belgium, Luxembourg and Switzerland, 5 otherwise.
 */
export const getPostalCodeLength = (country) =>
  POSTAL_CODE_LENGTHS[country] || 5;
